import { useParams } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * Site type the screen being rendered belongs to, lowercased.
 *
 * The signed-in clinic decides it. The `:tenant` segment of the URL is only a
 * fallback, for the moment before a clinic is known: a clinic under a parent
 * site is reached through the parent's segment, so the URL alone would name the
 * wrong site type.
 *
 * One helper because everything that keys off the site type has to agree — the
 * clinic shell, the tenant-scoped routes and the module registry. When they
 * disagree, a screen renders inside one site's shell while resolving another
 * site's component.
 */
export function useSiteType(): string {
  const { tenant } = useParams<{ tenant: string }>();
  const { clinic } = useAuth();
  return (clinic?.site_type ?? tenant ?? '').toLowerCase();
}

export default useSiteType;
